export const ProfileDev = {
    // 网关服务的地址
    // MATRIX_GATEWAY_SERVICE_HOST: "http://192.168.31.131:8080",
    MATRIX_GATEWAY_SERVICE_HOST: "http://localhost:8080",
    //
    // 登录页面
    MATRIX_LOGIN_PAGE_URL: "http://localhost:3000/account/user/login",

    // 连接 VMS Web Socket 服务的默认地址
    VMS_WEB_SOCKET_HOST: "ws://192.168.31.131:8090",

    // 连接护照扫描仪 Web Socket 服务的默认地址
    VMS_WEB_SOCKET_HOST_PASSPORT: "ws://127.0.0.1:90",

    // 注册登记的公众号 ID
    WECHAT_APP_ID: "wx1b960367423a2a00",

    // 微信跳转认证页
    WECHAT_AUTH_DOMAIN: "http://wechat-oauth.iidooo.com",

    // 微信的认证页面
    WECHAT_AUTH_PAGE: "WeChatOAuthRedirectDev.html",

    TENANT_ID: "f48d0b7509d9474db487eb4994cfc705",
    // QRCode跳转主页
    QRCODE_HOST_URL: "https://vms.iidooo.com",
}